import {
  SET_VISIBLE_FIELDS,
  SET_ADMIN_VISIBLE_FIELDS
} from 'Profiles/constants/detailsFields'

const initialProfileState = {
  visibleFields: [],
  adminVisibleFields: []
}

const initialState = {
  deals: { ...initialProfileState },
  companies: { ...initialProfileState },
  people: { ...initialProfileState },
  customers: { ...initialProfileState }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_VISIBLE_FIELDS: {
      const { profileType, fields } = action.payload
      return {
        ...state,
        [profileType]: {
          ...state[profileType],
          visibleFields: fields
        }
      }
    }

    case SET_ADMIN_VISIBLE_FIELDS: {
      const { profileType, fields } = action.payload
      return {
        ...state,
        [profileType]: {
          ...state[profileType],
          adminVisibleFields: fields
        }
      }
    }

    default:
      return state
  }
}

export default reducer
